export default __webpack_public_path__ + "static/media/widget-more-options.26a6b9c3.svg";